<script setup lang="ts">
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { type PropType, reactive, watch } from 'vue'

const props = defineProps({
  field: {
    type: Object as PropType<ObjectInventoryField>,
    required: true,
  },
  hideMandatory: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update'])

const currentValues = reactive({
  mandatory: Boolean(props.field?.mandatory),
})

/** Обновляем данные поля */
watch(currentValues, () => {
  emits('update', { ...props.field, ...currentValues })
})
</script>

<template>
  <VCheckbox
    v-if="!hideMandatory"
    v-model="currentValues.mandatory"
    :label="$t('itf.required')"
  />
</template>
